interface FirebaseMessage {
  data: FirebaseMessageData;
}

enum FirebaseMessageDataType {
  Generic = 'Generic',
  NewListing = 'NewListing',
  ListingPriceChange = 'ListingPriceChange',
  NewBlogPost = 'NewBlogPost'
}

interface FirebaseMessageData {
  id: string;
  senderId: string;
  type: FirebaseMessageDataType;
  title: string;
  body: string;
  image: string;
  imageAspectRatio: number;
  dwell: number;
  href: string;
}

export { FirebaseMessage, FirebaseMessageDataType, FirebaseMessageData }
